import { render, staticRenderFns } from "./AddEditLimitModal.vue?vue&type=template&id=4874a4a0"
import script from "./AddEditLimitModal.vue?vue&type=script&lang=ts"
export * from "./AddEditLimitModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports